/**
 * Indian numbering: lakh (1,00,000) and crore (1,00,00,000). Compact for KPIs.
 */
export function formatINRCompact(amount: number, opts: { signed?: boolean } = {}): string {
  if (!Number.isFinite(amount)) return '—';
  const sign = opts.signed && amount > 0 ? '+' : '';
  const abs = Math.abs(amount);
  let value: string;

  if (abs >= 1_00_00_000) {
    value = `${(amount / 1_00_00_000).toFixed(abs >= 10_00_00_000 ? 1 : 2)}Cr`;
  } else if (abs >= 1_00_000) {
    value = `${(amount / 1_00_000).toFixed(abs >= 10_00_000 ? 1 : 2)}L`;
  } else if (abs >= 1_000) {
    value = `${(amount / 1_000).toFixed(abs >= 10_000 ? 1 : 2)}K`;
  } else {
    value = amount.toFixed(0);
  }

  return `${sign}₹${value}`;
}

export function formatINRFull(amount: number): string {
  if (!Number.isFinite(amount)) return '—';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatNumberCompact(n: number): string {
  if (!Number.isFinite(n)) return '—';
  const abs = Math.abs(n);
  if (abs >= 1_00_00_000) return `${(n / 1_00_00_000).toFixed(1)}Cr`;
  if (abs >= 1_00_000) return `${(n / 1_00_000).toFixed(1)}L`;
  if (abs >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return n.toFixed(0);
}
